import { TrashIcon } from '@heroicons/react/20/solid';

import { PreviewImageThumbnail } from './PreviewImageThumbnail';

interface IUploadPreviewContent {
  filePath: string;
  basePath: string;
  onPreview: (filePath: string) => void;
  onRemoveContent: (filePath: string) => void;
}

/**
 * -----------------------------------------------------------------------------
 * Displays that the image has already been uploaded.
 */
export function PreviewUploadContent({
  filePath,
  basePath,
  onPreview,
  onRemoveContent,
}: IUploadPreviewContent) {
  const handleOnClickRemove = () => {
    onRemoveContent(filePath);
  };

  return (
    <div
      className="
        group relative flex h-36 w-[calc(50%-4px)] cursor-pointer flex-col
        items-center rounded-xl border border-gray-200 bg-gray-100 transition-all
        duration-300 ease-in
      "
    >
      <PreviewImageThumbnail
        basePath={basePath}
        filePath={filePath}
        onPreview={onPreview}
      />
      {/* <PreviewFileThumbnail /> */}

      <div
        className="
          absolute top-0 z-[2] grid gap-x-2 p-2 ltr:right-0 rtl:left-0
        "
      >
        <button
          className="
            group-hover:bg-primary-100 hover:!bg-primary-500 focus:!bg-primary-300
            focus:ring-primary-100 focus:outline-primary-200 rounded-lg border-2 bg-gray-50/90
            p-1 text-gray-600 transition-all duration-300 ease-in hover:text-white
          "
          onClick={handleOnClickRemove}
          title="Remove this attachment"
          type="button"
        >
          <TrashIcon className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
}
